import { Details, Document } from '../components';

interface ViewComponentProps {
  /**
   * Name of field
   */
  arrayName: string;
  /**
   * Default value for field
   */
  index: number;
}

const ViewComponent = ({ ...props }: ViewComponentProps) => (
  <div className="flex flex-col">
    <span className="my-6 text-16-20-em">Add quote</span>
    <Document {...props} />
    <Details {...props} />
  </div>
);

ViewComponent.displayName = 'Createjob-Quote-Custom-Item-Mobile-view';

export default ViewComponent;
